import React, { useEffect } from "react";
import { Loading } from "../../../components";
import { ScansFiltersInput } from "../../../__generated__/globalTypes";
import { useScans } from "../hooks";
import { Activity } from "lucide-react";
import { Card } from "../../../components/cards";

export const ScansInfos: React.FC<ScansFiltersInput> = (where) => {
  const limit = 999;
  const { data, loading } = useScans({ where, limit, offset: 0 });

  return (
    <Card hover padding="sm" className="shadow-sm border border-gray-200">
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
            Scans
          </p>
          <p className="text-sm sm:text-lg font-bold text-gray-900 truncate">
            {loading ? "Loading..." : data?.scans?.total || 0}{" "}
          </p>
          <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
            Scans effecutés
          </p>
        </div>
        <div className="bg-orange-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
          <Activity className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" />
        </div>
      </div>
    </Card>
  );
};
